import {Colors} from '../../../theme/colours'
import {type IconStyleProps} from './icon.types'

import type {JSX} from 'react'

export type CloseIconProps = {
    color?: string
} & Omit<IconStyleProps, 'color'>

export function CrossIcon({color = Colors.blue2}: CloseIconProps): JSX.Element {
    return (
        <svg
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.97529 1.02454L1 9M1.02471 1L9 8.97546"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
